import React, {
  useMemo,
  useState
} from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import Cart from './CartModal';
import { LIGHT_PINK_ORANGE } from '../../colors';
import { NavLink } from '../../typography';
import { useCart } from '../../../contexts/CartContext';
import { useAuth } from '../../../contexts/AuthContext';

const LogoImg = require('../../../assets/hg-logo.png');


interface NavigationInterface {}

const Navigation = ({}: NavigationInterface) => {
  const navigate = useNavigate();
  const {
    cart,
    isCartOpen,
    setIsCartOpen
  } = useCart();
  const {
    user
  } = useAuth();

  const navigations = useMemo(() => {
    return [{
      label: 'SHOP',
      onPress: () => {
        navigate('/shop');
      }
    }, {
      label: 'TRACK',
      onPress: () => {
        navigate('/track');
      }
    }, {
      label: 'ACCOUNT',
      onPress: () => {
        navigate( user? '/account' : '/login');
      }
    }, {
      label: `CART(${cart.length || 0})`,
      onPress: () => {
        setIsCartOpen(true);
      }
    }]
  }, [user, cart])

  return (
    <>
      <Cart 
        onProceedCheckout={() => {
          setIsCartOpen(false);
          navigate('/checkout')
        }}
      />
      { !isCartOpen &&
        <Container>
          <Logo>
            <div>
              <img src={LogoImg} />
            </div>
          </Logo>

          <Nav>
            <ul>
              {navigations.map((navItem) => (
                <li>
                  <NavLink
                    onClick={navItem.onPress}
                  >
                    {navItem.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </Nav>

        </Container>
      }
    </>
  )
}

const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 999; // ensures it's above other content
  background: ${LIGHT_PINK_ORANGE};
  display: flex;
  flex-direction: row;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); // optional: subtle shadow when sticky
  max-height: 40px;
`;

const Logo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  div {
    height: 24px;
    padding-left: 0.5rem;
    img {
      width: auto;
      height: 24px;
      object-fit: cover;
    }
  }
`;

const Nav = styled.div`
  flex-direction: column;
  display: flex;
  flex-grow: 1;
  justify-content: center;

  ul {
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: flex-end;

    li {
      list-style: none;
      padding: 0rem 0.5rem;

      a {
        cursor: pointer;
        font-family: 'Poppins-Light';
        font-size: 0.rem;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
        color: black;
      }
    }
  }
`;

export default Navigation;

